import { render, staticRenderFns } from "./TheWelcomeTags.vue?vue&type=template&id=d7888c00&scoped=true&"
import script from "./TheWelcomeTags.vue?vue&type=script&lang=ts&"
export * from "./TheWelcomeTags.vue?vue&type=script&lang=ts&"
import style0 from "./TheWelcomeTags.vue?vue&type=style&index=0&id=d7888c00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7888c00",
  null
  
)

export default component.exports